/**
 * localStorage is unavailable in sandboxed iframes without allow-same-origin
 * (Zep widgets → origin null). Fall back to an in-memory map for the session.
 */
const memory = new Map();

function createMemoryStorage() {
  return {
    getItem(key) {
      return memory.has(key) ? memory.get(key) : null;
    },
    setItem(key, value) {
      memory.set(String(key), String(value));
    },
    removeItem(key) {
      memory.delete(key);
    },
  };
}

function resolveStorage() {
  try {
    const storage = window.localStorage;
    const probe = "__w2l_storage_probe__";
    storage.setItem(probe, "1");
    storage.removeItem(probe);
    return storage;
  } catch {
    return createMemoryStorage();
  }
}

const storage = resolveStorage();

export function getItem(key) {
  try {
    return storage.getItem(key);
  } catch {
    return null;
  }
}

export function setItem(key, value) {
  try {
    storage.setItem(key, value);
  } catch {
    // ignore
  }
}
